// Imports
import React from 'react';
import { Params, useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../../shareables/foundation/front-end/redux/hooks';
import PageTitle from '../shared-components/page-title';
import LeadingText from '../shared-components/leading-text';


// Define the accepted props
interface Props {
	title: string;
}


// Function component
const InsufficientPrivileges: React.FC<Props> = ({ title }) => {
	// Use Redux functionality
	const pages = useAppSelector((state) => state.self.pages);
	
	
	// Use React Router functionality
	const { pageIdentifier } = useParams<Params>();
	
	
	// Attempt to get page title if page ID is provided
	const foundPageTitle = pages?.find((page) => page.id === parseInt(pageIdentifier ?? ''))?.title;
	
	
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle documentTitle={foundPageTitle ?? title}>Insufficient privileges</PageTitle>
			<LeadingText>
				Viewing this content or completing this action is not allowed, because you do not have sufficient privileges.
				This may be limited to specific residents, like board members or committee members. Your account may also be
				pending review, temporarily suspended, or denied access. For questions about this restriction, please contact
				one of your website administrators.
			</LeadingText>
		</React.Fragment>
	);
};

export default InsufficientPrivileges;
